export default "__VITE_ASSET__CxyWNBQ3__"